'use client'

import {Text} from '@/components/ui/Typography'
import {useRouter} from '@/i18n/navigation'
import {Product} from '@/types/box/Product'
import Image from 'next/image'
import React from 'react'

interface Props {
  activity: Product
}

export const Activity: React.FC<Props> = ({activity}) => {
  const router = useRouter()

  const handleClick = (productUrl: string) => {
    router.push(productUrl)
  }

  return (
    <button
      key={activity.id}
      className="relative flex flex-col items-center justify-center bg-white p-4 border hover:shadow-md transition-shadow cursor-pointer"
      onClick={() => handleClick(activity.url)}
      title={activity.description}
    >
      {/* Centered image */}
      {activity.iconUrl && (
        <Image src={activity.iconUrl} alt={activity.name} title={activity.name} height={56} width={56} className="h-16 w-16 mb-2" />
      )}

      {/* Product name */}
      <div className="text-center">
        <Text className="text-gray-700">{activity.name}</Text>
      </div>
    </button>
  )
}
